import {useState, useEffect} from "react";

import {getAnalysis} from "../../utils/helpers";

import AnalysisItem from "../Analysis/AnalysisItem";
import AnalysisDetails from "../Analysis/AnalysisDetails";

const Dashboard = () => {
  const [documents, setDocuments] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const processGetAnalysis = async () => {
    setIsLoading(true);
    const response = await getAnalysis();

    if (response.status === 200) {
      response.result.sort((a, b) => {
        return new Date(b.last_updated) - new Date(a.last_updated);
      });
      console.log(
        `[Dashboard -> Get Analysis]: Response -> ${JSON.stringify(
          response.result
        )}`
      );
      setDocuments(response.result);
      setSelectedDocument(response.result[0]);
    } else {
      setDocuments([]);
      setSelectedDocument();
    }
    setIsLoading(false);
  };

  useEffect(() => {
    processGetAnalysis();
  }, []);

  const selectSessionHandler = (document) => {
    setSelectedDocument(document);
  };

  return (
    <div className="min-h-screen w-full flex flex-col bg-gradient-to-br from-gray-50 to-gray-100">
      {isLoading && (
        <div
          className="absolute top-[10%] inset-0 flex items-center justify-center bg-gray-500 bg-opacity-40 backdrop-blur-md z-50 transition-opacity duration-500 opacity-100"
          style={{
            animation: "fadeIn 0.5s ease-out forwards",
          }}
        >
          <style>
            {`
                        @keyframes fadeIn {
                            from { opacity: 0; }
                            to { opacity: 1; }
                        }
                        .font-inter {
                            font-family: 'Inter', sans-serif;
                        }
                        /* Bouncing dots animation */
                        @keyframes bounce {
                            0%, 80%, 100% {
                                transform: translateY(0);
                            }
                            40% {
                                transform: translateY(-10px);
                            }
                        }

                        .dot {
                            animation: bounce 1s infinite ease-in-out both;
                        }

                        .dot-1 {
                            animation-delay: -0.32s;
                        }
                        .dot-2 {
                            animation-delay: -0.16s;
                        }
                        .dot-3 {
                            animation-delay: 0s;
                        }
                        `}
          </style>
          <div className="flex flex-col items-center">
            <div className="flex space-x-2">
              <div className="dot dot-1 w-4 h-4 bg-white rounded-full"></div>
              <div className="dot dot-2 w-4 h-4 bg-white rounded-full"></div>
              <div className="dot dot-3 w-4 h-4 bg-white rounded-full"></div>
            </div>
          </div>
        </div>
      )}
      {!isLoading && (
        <>
          <header className="bg-white w-full h-[7vh] border-t border-gray-300 text-gray-800 flex items-center justify-end shadow-md">
            <img
              src="./images/refresh-icon.svg"
              className="cursor-pointer m-4"
              onClick={() => processGetAnalysis()}
              alt="refresh"
            />
          </header>
          <main className="flex-1 w-full h-[93vh] flex items-center">
            <div className="w-1/4 h-full border-r border-gray-300">
              <div className="space-y-2 p-4 h-[90%] overflow-y-auto">
                {documents.length > 0 ? (
                  documents.map((document) => (
                    <AnalysisItem
                      document={document}
                      selectedDocument={selectedDocument}
                      onSelectDocument={selectSessionHandler}
                    />
                  ))
                ) : (
                  <p className="text-center text-gray-500 italic">
                    No sessions to display.
                  </p>
                )}
              </div>
            </div>

            <div className="w-3/4 h-full overflow-y-auto">
              <AnalysisDetails selectedDocument={selectedDocument} />
            </div>
          </main>
        </>
      )}
    </div>
  );
};

export default Dashboard;
